var Fields = {
  CARD_NUMBER: 'card-number',
  CVV: 'cvv',
  EXPIRY: 'expiry',
};

module.exports = Fields;


// WEBPACK FOOTER //
// ./app/fields.js